import { paginatedAuditLogSchema } from "../../schemas/audit-log";
import { fetchApi } from "../client/internal";

export type AuditLogListParams = {
	limit?: number;
	offset?: number;
	entity_type?: string;
	action?: string;
	actor_id?: string;
	from?: string;
	to?: string;
};

export const auditLogs = {
	list: (clubId: string, params: AuditLogListParams = {}) => {
		const searchParams = new URLSearchParams();
		if (params.limit !== undefined) searchParams.set("limit", String(params.limit));
		if (params.offset !== undefined) searchParams.set("offset", String(params.offset));
		if (params.entity_type !== undefined) searchParams.set("entity_type", params.entity_type);
		if (params.action !== undefined) searchParams.set("action", params.action);
		if (params.actor_id !== undefined) searchParams.set("actor_id", params.actor_id);
		if (params.from !== undefined) searchParams.set("from", params.from);
		if (params.to !== undefined) searchParams.set("to", params.to);

		const qs = searchParams.toString();
		return fetchApi(`/${clubId}/audit${qs ? `?${qs}` : ""}`, paginatedAuditLogSchema);
	},
};
